import { Component, Input } from '@angular/core';
import {CollectionService} from "../../services/collection.service";
import {JP} from "../../helpers/jp";
import {IDocument} from "../../interfaces/document.definition";

@Component({
  selector: 'nv-additional-reward',
  templateUrl: './nv-additional-reward.component.html',
  styles: []
})
export class NvAdditionalRewardComponent {
  
  private _document:any;
  private _pointer:string;
  private _enabled:boolean;
  private _autoReward:boolean;

  constructor(private collectionService:CollectionService) {
    
  }
  
  private updateModel():void {

    if (this.document && this.pointer)
    {
      this.enabled = JP.has(this.document, this.pointer);
      this._autoReward = JP.has(this.document, this.pointer+"/autoReward") && JP.get(this.document, this.pointer+"/autoReward");
    }
    else
    {
      this.enabled = false;
    }
  }
  
  @Input() set document(v:any) {
    this._document = v;
    this.updateModel();
  }
  get document() {
    return this._document;
  }
  
  @Input() set pointer(v: string) {
    this._pointer = v;
    this.updateModel();
  }
  get pointer() {
    return this._pointer;
  }

  set enabled(val:boolean) {
    this._enabled = val;
    JP.set(this.document, "/admin/hasAdditionalReward", val);
  }

  get enabled():boolean {
    return this._enabled;
  }
  
  onCheckboxUpdated(val:boolean) {
    this.enabled = val;
    if (this.enabled)
    {
      this.autoReward = true;
    }
    else if (JP.has(this.document, this.pointer))
    {
      JP.remove(this.document, this.pointer);
    }
  }

  set autoReward(val:boolean) {
    this._autoReward = val;
    JP.set(this.document, this.pointer+"/autoReward", val);
  }

  get autoReward():boolean {
    return this._autoReward;
  }

  onAutoRewardCheck(val:boolean) {
	this.autoReward = val;
    if (!this.autoReward)
    {
      JP.set(this.document, this.pointer+"/rewards", []);
    }
    else if (this.autoReward)
    {
      JP.remove(this.document, this.pointer+"/rewards");
    }
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-additional-reward/nv-additional-reward.component.ts